import { useDispatch, useSelector } from "react-redux";
import { setFilterOpenNow } from "../../../store";
import { Box, Checkbox } from "@mui/joy";

function FilterOpenNow() {
  const dispatch = useDispatch();
  const filterValue = useSelector((state) => state.filter.openNow);
  const selectedOption = filterValue === null ? false : true;
  return (
    <Box>
      <Checkbox
        label="Open Now"
        checked={selectedOption}
        onChange={(event) => {
          if (event.target.checked) {
            dispatch(setFilterOpenNow(true));
          } else {
            dispatch(setFilterOpenNow(null));
          }
        }}
      />
    </Box>
  );
}

export default FilterOpenNow;
